import { InputWithLabel } from '@adotel/components'
import { Box, Button, CircularProgress, Typography } from '@material-ui/core'
import { useState } from 'react'

import * as notificationGraphql from '../../graphql/notifications'
import { useCursorPage } from '../../helpers/useCursorPage'
import { formatNotificationTime } from './notificationAccess'
import {
  EmptyState,
  ErrorState,
  LoadMoreButton,
  RETAINED_RESULTS,
  t
} from './shared'
import { PreferenceChangeRow } from './types'

export function PreferenceHistory() {
  const [userId, setUserId] = useState('')
  const [draftUserId, setDraftUserId] = useState('')
  const {
    items: rows,
    loading,
    error,
    hasMore,
    loadMore,
    refetch
  } = useCursorPage<Record<string, any>, PreferenceChangeRow>({
    query: notificationGraphql.NOTIFICATION_PREFERENCE_CHANGES_QUERY,
    variables: { userId },
    maxRetained: RETAINED_RESULTS,
    // This list's identity is a prop. Firing without it would ask the backend
    // for a preference history with no subject.
    skip: !userId,
    getPage: (data) =>
      data && {
        items: data.notificationPreferenceChanges?.changes ?? [],
        nextPageToken: data.notificationPreferenceChanges?.page?.nextPageToken
      },
    withItems: (data, items) => ({
      ...data,
      notificationPreferenceChanges: {
        ...data.notificationPreferenceChanges,
        changes: items
      }
    })
  })
  return (
    <Box mt={4}>
      <Typography variant="h6">{t('Preference change history')}</Typography>
      <InputWithLabel
        id="notification-preference-history-user"
        inputSize="small"
        label={t('User ID')}
        noHelperText
        type="text"
        value={draftUserId}
        onChange={(event) => setDraftUserId(event.currentTarget.value)}
      />
      <Button onClick={() => setUserId(draftUserId.trim())}>
        {t('Search')}
      </Button>
      {loading && (
        <CircularProgress aria-label={t('Loading preference history')} />
      )}
      {error && (
        <ErrorState
          message="Unable to load preference history."
          onRetry={() => refetch()}
        />
      )}
      {userId && !loading && !error && rows.length === 0 && (
        <EmptyState label="Preference changes" />
      )}
      {rows.map((row) => (
        <Box key={row.id} mb={1}>
          <Typography>
            {row.categoryKey} · {row.channel}: {String(row.oldEnabled)} →{' '}
            {String(row.newEnabled)}
          </Typography>
          <Typography color="textSecondary">
            {formatNotificationTime(row.changedAt)}
          </Typography>
        </Box>
      ))}
      {hasMore && <LoadMoreButton onLoadMore={async () => loadMore()} />}
    </Box>
  )
}
